// The Terms of Service / Privacy Policy / age checkbox from the account
// creation screen.
//
// The client asked for ONE checkbox in ONE consistent location that gates
// Apple, Google and email signup alike. Those three paths finish in three
// different places (a social-login POST, a signup POST, a route change), so the
// answer is stashed here between the tick and whichever request finally creates
// the account, and sent to the backend with it. The backend re-checks it - the
// stash is a convenience, never the source of truth.

const KEY = "qushi_legal_accepted";

export const LEGAL_TERMS_URL = "https://qushi.io/terms-of-service/";
export const LEGAL_PRIVACY_URL = "https://qushi.io/privacy-policy/";

// The exact wording the client specified for the inline error.
export const LEGAL_ACCEPTANCE_ERROR =
  "Please confirm your agreement and age eligibility to continue.";

export const setLegalAccepted = () => {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ accepted: true, accepted_at: new Date().toISOString() })
    );
  } catch (e) {}
};

export const hasLegalAccepted = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null")?.accepted === true;
  } catch (e) {
    return false;
  }
};

export const clearLegalAccepted = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
};

// Sent alongside signup / social-login. 1 or 0 rather than a boolean because
// both requests go out as multipart/form-data.
export const legalAcceptedFlag = () => (hasLegalAccepted() ? 1 : 0);
